import React from 'react';
import '../styles/TermsOfService.css';
import logo from '../assets/logo.webp'; // Substitua pelo caminho correto da sua imagem

const TermsOfService: React.FC = () => {
    return (
      <div className="terms-container">
        <div className="logo-container">
          <img src={logo} alt="Susten City Logo" className="logo" />
        </div>
        <div className="content">
          <h1>Termos de Serviços e Uso</h1>
          <p>Bem-vindo ao Susten City! Estes Termos de Serviço regem o uso do aplicativo Susten City. Ao usar nosso aplicativo, você concorda com estes termos.</p>
  
          <h2>1. Coleta de Dados</h2>
          <p>O Susten City coleta e utiliza os seguintes tipos de dados:</p>
          <ul>
            <li><strong>Localização:</strong> Para identificar pontos de coleta de resíduos e calcular a distância para as instalações de reciclagem.</li>
            <li><strong>Acesso à Galeria de Imagens:</strong> Para permitir que os usuários enviem fotos de resíduos reciclados.</li>
            <li><strong>Acesso à Câmera:</strong> Para tirar fotos dos resíduos e das coletas realizadas.</li>
            <li><strong>Dados Pessoais:</strong> Incluindo nome, e-mail, endereço e número de celular para criação de perfil e comunicação.</li>
          </ul>
  
          <h2>2. Uso de Dados</h2>
          <p>Os dados coletados são utilizados para fornecer e melhorar nossos serviços, incluindo:</p>
          <ul>
            <li>Identificar e recomendar pontos de coleta de resíduos.</li>
            <li>Comunicar-se com os usuários sobre atualizações e serviços.</li>
            <li>Personalizar a experiência do usuário.</li>
          </ul>
  
          <h2>3. Compartilhamento de Dados</h2>
          <p>O Susten City não compartilha seus dados pessoais com terceiros, exceto conforme exigido por lei ou para proteger nossos direitos.</p>
  
          <h2>4. Direitos dos Usuários</h2>
          <p>De acordo com a LGPD e o GDPR, você tem o direito de acessar, corrigir ou excluir seus dados pessoais. Para exercer esses direitos, entre em contato conosco.</p>
  
          <h2>5. Segurança dos Dados</h2>
          <p>Implementamos medidas de segurança para proteger seus dados pessoais contra acesso não autorizado e outras ameaças.</p>
  
          <h2>6. Alterações nos Termos</h2>
          <p>Podemos atualizar estes Termos de Serviço periodicamente. Notificaremos os usuários sobre quaisquer alterações significativas.</p>
  
          <h2>7. Contato</h2>
          <p>Para perguntas ou preocupações sobre estes termos, entre em contato conosco através do e-mail: suporte@sustencity.com.</p>
  
          <div className="footer">
            <p>Susten City ® 2024</p>
          </div>
        </div>
      </div>
    );
  };
  
  export default TermsOfService;